export enum DuplicateDebtors {
  SEARCH_DUPLICATING_DEBTORS = "SEARCH_DUPLICATING_DEBTORS",
  SEARCH_DUPLICATING_DEBTORS_SUCCESS = "SEARCH_DUPLICATING_DEBTORS_SUCCESS",
  SEARCH_DUPLICATING_DEBTORS_FAIL = "SEARCH_DUPLICATING_DEBTORS_FAIL",

  SELECT_DUPLICATE_DEBTORS = "SELECT_DUPLICATE_DEBTORS",
  CHANGE_RETAINING_DEBTOR = "CHANGE_RETAINING_DEBTOR",

  MERGE_DUPLICATE_DEBTORS = "MERGE_DUPLICATE_DEBTORS",
  MERGE_DUPLICATE_DEBTORS_SUCCESS = "MERGE_DUPLICATE_DEBTORS_SUCCESS",
  MERGE_DUPLICATE_DEBTORS_FAIL = "MERGE_DUPLICATE_DEBTORS_FAIL",

  GET_DUPLICATE_DEBTORS_HISTORY = "GET_DUPLICATE_DEBTORS_HISTORY",
  GET_DUPLICATE_DEBTORS_HISTORY_SUCCESS = "GET_DUPLICATE_DEBTORS_HISTORY_SUCCESS",
  GET_DUPLICATE_DEBTORS_HISTORY_FAIL = "GET_DUPLICATE_DEBTORS_HISTORY_FAIL",
}
